module.exports = __webpack_public_path__ + "static/media/footer-white-mask.1d3d4d71.png";